import actions from "./actions";
import mutations from "./mutations";

const state = {
  miniNav: true,
  SET_TOKEN_EXPIRED: false,
  temp_password: [],
  res_role: [],
  temp_role: [],
  idrole: null,
  res_menu: [],
  res_accesslist: [],
  dataCreateAccess: [],
  dataDeleteAccess: [],
  res_authMenu: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
